import {toastr} from 'react-redux-toastr';
import history from '../history/history';



function callApi(url, type, data = {}) {

    let config = {};

    //let url = BASE_URL;


    /*
    if(type === 'GET' || type === 'DELETE') {

        config = {
            method: type,
            headers: { 'Content-Type':'application/json', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache', 'Expires': 0 },
            cache: "no-cache"
        };
    } else if(type === 'POST' || type === 'PUT') {
        config = {
            method: type,
            headers: { 'Content-Type':'application/json', 'Cache-Control': 'no-cache, no-store, must-revalidate', 'Pragma': 'no-cache', 'Expires': 0 },
            cache: "no-cache",
            body: JSON.stringify(data)
        };
    }
    */

    config = {
        method: type,
        body: JSON.stringify(data)
    };

    return fetch(url, config)
        .then(function(response) {
            if (!response.ok) {
                return Promise.reject(response);
            } else {
                return response.json();
            }

        }).then(function(response) {
            if(response.alert && response.alert.message) {
                APInotify(response.alert.type, response.alert.message);
            }
            if(typeof(response.redirect) !== 'undefined' && response.redirect !== false) {
                history.push(response.redirect);
            }
            return response;
        }).catch(err => {
            return Promise.reject(err);
        });
}


function APInotify(type, message) {
  switch(type) {
      case "error":
          toastr.error('Fehler', message);
          break;
      case "success":
          toastr.success('Erfolgreich', message);
          break;
      case "warning":
          toastr.warning('Hinweis', message);
          break;
      case "info":
          toastr.info('Info', message);
          break;
      case "hidden":
      case false:
      case "false":
          break;
      default:
          toastr.error('Fehler', "Ein unbekannter Fehler ist aufgetreten!");
  }
}

export const CALL_API = Symbol('Call API');

export default store => next => action => {
  
  const callAPI = action[CALL_API];



  
  // So the middleware doesn't get applied to every single action
  if (typeof callAPI === 'undefined') {
    return next(action);
  }
  
  let { url, types, reqType, postData, auth, pure } = callAPI;
  
  const [ requestType, successType, errorType ] = types;


    next({
        type: requestType
    });

    return callApi(url ,reqType, postData, auth, pure).then(

        response =>
            next({
                response,
                type: successType
            }),
                function(error) {


                        if (error.status === 400) {


                                error.json().then(result => {
                                    if (result.alert && result.alert.message) {
                                        APInotify(result.alert.type, result.alert.message);
                                    }
                                    next({
                                        type: errorType,
                                        message: result.alert.message
                                    });
                                });


                        } else {
                            toastr.error('Fehler', "Es ist ein unbekannter Fehler aufgetreten. (ERRORCODE: UNSPECIFIED)");
                            next({
                                type: errorType
                            });
                        }
                }
    );
};






// WEBPACK FOOTER //
// ./src/middleware/api.js